export default {
  steps: {
    discount: 'Alennus',
    mobile_app: 'Mobiilisovellus',
    business_info: 'Yrityksen tiedot',
    create_preview: 'Luo esikatselusopimus',
    preview: 'Esikatsele sopimus',
    sign: 'Allekirjoita sopimus',
  },
  buttons: {
    back: 'Takaisin',
    continue: 'Jatka',
  },
  agreement:
    'Vuosimaksuun vaihtaminen antaa {{discount}} %:n alennuksen {{plan}}-paketillesi. Laskutuksesi jatkuu kuukausittain hintaan {{amount}}/kk {{months}} kuukauden sitoumuksella.',
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    failed_to_switch: 'Vuosimaksuun vaihtaminen epäonnistui',
    switched_to_annual: 'Sopimus vaihdettu vuosimaksuun 👌',
  },
};
